"use strict";

const Hold = require('bunsen/models/inventory/Hold');
const SoaCollection = require('bunsen/collections/SoaCollection');
const reduce = require('lodash.reduce');

const Holds = SoaCollection.extend();

Object.assign(Holds.prototype, {
    model : Hold,

    getActiveHold: function () {
        return this.find(function (hold) { return hold.isActive(); });
    },

    getRelevantHoldByBuyer(buyerId) {
        const buyerHolds = this.filter(hold => hold.get('buyer.id') === buyerId);
        // only return hold if for passed in bueyrId
        if (!buyerHolds.length) {
            return null;
        }
        const hierarchy = {
            [Hold.statuses.ACTIVE]: 2,
            [Hold.statuses.REQUESTED]: 1,
            [Hold.statuses.DELETED]: 0
        };
        return reduce(buyerHolds, (mostRelevant, current) => {
            const relevantStatus = mostRelevant.get('status');
            const currentStatus = current.get('status');
            let relevantScore;
            let currentScore;
            // for same status, use modified date to break tie
            if (relevantStatus === currentStatus) {
                relevantScore = new Date(mostRelevant.get('modifiedDate')).getTime();
                currentScore = new Date(current.get('modifiedDate')).getTime();
            // ACTIVE beats REQUESTED beats DELETED
            } else {
                relevantScore = hierarchy[relevantStatus];
                currentScore = hierarchy[currentStatus];
            }
            return relevantScore > currentScore ? mostRelevant : current;
        });
    }
});

module.exports = Holds;



// WEBPACK FOOTER //
// ./~/bunsen/collections/inventory/Holds.es.js